import React from "react"
import {
  Breadcrumb,
  BreadcrumbItem,
  UncontrolledButtonDropdown,
  DropdownMenu,
  DropdownItem,
  DropdownToggle
} from "reactstrap"
import { Home, Settings } from "react-feather"
import { NavLink } from "react-router-dom"
class BreadCrumbs extends React.Component {
  render() {
    return (
      <div className="content-header row">
        <div className="content-header-left col-md-9 col-12">
          <div className="row breadcrumbs-top">
            <div className="col-12 align-items-center justify-content-center">
              {this.props.breadCrumbTitle ? (
                <h2 className="content-header-title float-left mb-0"
                  style={{    height: '100%',
                    fontSize: '1.3rem',
                    display: 'flex',
                    alignItems: 'center',
                    paddingLeft: '10px',
                    color: 'black',
                    fontWeight: 'bold',
                  }}
                >
                  {this.props.breadCrumbTitle}
                </h2>
              ) : (
                ""
              )}
              <div className="breadcrumb-wrapper vx-breadcrumbs d-sm-block d-none col-12">
                <Breadcrumb tag="ol" className={'mb-0'}>
                  <BreadcrumbItem tag="li">
                    <NavLink to="/">
                      <Home className="align-top" size={15} style={{marginTop: '2px'}} />
                    </NavLink>
                  </BreadcrumbItem>
                  {this.props.breadCrumbParent ?
                  <BreadcrumbItem tag="li" className="text-primary" style={{fontWeight: 'bold'}}>
                    {this.props.breadCrumbParent}
                  </BreadcrumbItem> : ('')}
                  {this.props.breadCrumbParent2 ? (
                    <BreadcrumbItem tag="li" className="text-primary" style={{fontWeight: 'bold'}}>
                      {this.props.breadCrumbParent2}
                    </BreadcrumbItem>
                  ) : (
                    ""
                  )}
                  {this.props.breadCrumbParent3 ? (
                    <BreadcrumbItem tag="li" className="text-primary" style={{fontWeight: 'bold'}}>
                      {this.props.breadCrumbParent3}
                    </BreadcrumbItem>
                  ) : (
                    ""
                  )}
                  <BreadcrumbItem tag="li" active style={{fontWeight: 'bold'}}>
                    {this.props.breadCrumbActive}
                  </BreadcrumbItem>
                </Breadcrumb>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}
export default BreadCrumbs
